import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'
import { microsoftUserLoginAPI } from '../../../../utils/api'
import {
  StyledLoginFormWrapper,
  StyledHeading,
  StyledWelcomeMessage,
  StyledForm
} from './styled'
import { ROUTES } from '../../../../consts/Routes'
import CustomSnackBar from '../../../../components/CustomSnackBar'
import { SnackBarMessageType } from '../../../../consts/SnackbarMessageTypes'
import Button from '@mui/material/Button'
import MicrosoftIcon from '@mui/icons-material/Microsoft'
import { useMsal } from '@azure/msal-react'
import { loginRequest, setToken } from '../../../../config/msAuthConfig'
import { useAppDispatch } from '../../../../reducers/hooks'
import { userReducer } from '../../../../reducers/user/userReducer'

const LoginForm: React.FC = (): JSX.Element => {
  const { instance } = useMsal()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [errorMessage, setErrorMessage] = useState('')
  const [isError, setIsError] = useState(false)

  const loginPopup = async (): Promise<any> => {
    try {
      const res = await instance.loginPopup(loginRequest)
      const params = {
        token: res.accessToken
      }
      const loginData = await microsoftUserLoginAPI(params)
      const idTokenClaims = res.idTokenClaims
      setToken(loginData?.payload?.token)
      dispatch(userReducer.actions.changeToken(loginData?.payload?.token))
      localStorage.setItem('token', loginData?.payload?.token)
      dispatch(userReducer.actions.changeInternalUser('true'))
      localStorage.setItem('internalUser', 'true')
      const uid = uuidv4()
      localStorage.setItem('sessionId', uid)
      dispatch(userReducer.actions.changeSessionId(uid))
      localStorage.setItem('platform', 'standalone')
      dispatch(userReducer.actions.changePlatform('standalone'))
      localStorage.setItem('username', (idTokenClaims as any).name)
      dispatch(userReducer.actions.changeUserName((idTokenClaims as any).name))
      localStorage.setItem('email', (idTokenClaims as any).preferred_username)
      dispatch(userReducer.actions.changeEmail((idTokenClaims as any).preferred_username))
      navigate(ROUTES.ADMIN_LOGIN)
    } catch (error) {
      setErrorMessage('Login failed. Please check your credentials.')
      setIsError(true)
      console.log(error)
    }
  }

  return (
    <>
      <StyledLoginFormWrapper>
        <StyledHeading>Login</StyledHeading>
        <StyledWelcomeMessage>Welcome to the Buyers Edge Platform Chat Bot Beta</StyledWelcomeMessage>
        <StyledForm >
          <Button variant='contained' startIcon={<MicrosoftIcon />} sx={{ width: '100%' }} onClick={() => { loginPopup().catch(console.error) }}>Log In with Microsoft</Button>
        </StyledForm >
      </StyledLoginFormWrapper >
      <CustomSnackBar isOpen={isError} onClose={setIsError} message={errorMessage} duration={5000} messageType={SnackBarMessageType.ERROR} />
    </>
  )
}

export default LoginForm
